var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-view-template-industry-cases',{staticClass:"app-view-template-industry-cases-financial",attrs:{"title":"Change is here - is your game plan ready?","brands":_vm.brands}},[_c('case-visa'),_c('case-jyske-bank')],1)}
var staticRenderFns = []

export { render, staticRenderFns }